// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-form label {
  margin-bottom: 12px;
  color: var(--dunkelgruen);
}

.dropdown-form select {
  background-color: var(--mittelgruen);
  padding: 10px 40px 10px 10px;
  margin-bottom: 12px;
  border: none;
  border-radius: 10px;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  text-transform: none;
}

.dropdown-form .dropdown-wrapper:not(.filled) select {
  color: var(--placeholder);
}

.dropdown-form .dropdown-wrapper.filled select {
  color: var(--dunkelgruen);
}

.dropdown-form select option[disabled],
.dropdown-form select option[value=""] {
  color: var(--placeholder);
}
`, "",{"version":3,"sources":["webpack://./src/styles/Dropdown.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B","sourcesContent":[".dropdown-form label {\n  margin-bottom: 12px;\n  color: var(--dunkelgruen);\n}\n\n.dropdown-form select {\n  background-color: var(--mittelgruen);\n  padding: 10px 40px 10px 10px;\n  margin-bottom: 12px;\n  border: none;\n  border-radius: 10px;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-transform: none;\n}\n\n.dropdown-form .dropdown-wrapper:not(.filled) select {\n  color: var(--placeholder);\n}\n\n.dropdown-form .dropdown-wrapper.filled select {\n  color: var(--dunkelgruen);\n}\n\n.dropdown-form select option[disabled],\n.dropdown-form select option[value=\"\"] {\n  color: var(--placeholder);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
